const USER_TYPE = {
    EMPLOYEE: 'EMPLOYEE',
    CLIENT: 'CLIENT'
};

const ACCT_TYPES = {
    ORGANIZATION: 'Organization',
    EMPLOYEE: 'Employee'
};

export {
    ACCT_TYPES,
    USER_TYPE
}